import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleJiraTicketModal } from '../../../redux/actions/jiraActions';
export const createTicketsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createTicket',
        popover: {
          title: 'Create New Ticket',
          description:
            'Use the "Create Ticket" feature to quickly document, assign, and track tasks or issues. This ensures that all tasks are properly managed from start to finish.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.filterTickets',
        popover: {
          title: 'Filter Tickets',
          description:
            'Filter the tickets based on assignee, status, or other criteria to focus on the tasks that matter most to you.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.openTickets',
        popover: {
          title: 'Open Tickets',
          description:
            'View all tickets that are currently open and in progress. This helps you keep track of ongoing tasks that need attention.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.closeTickets',
        popover: {
          title: 'Closed Tickets',
          description:
            'Access the list of tickets that have been completed and closed. Review these tickets to ensure all issues were resolved satisfactorily.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.overDueTickets',
        popover: {
          title: 'Overdue Tickets',
          description:
            'Check the Overdue Tickets tab to identify tasks that have missed their deadlines. These tickets should be prioritized to prevent further delays.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            console.log('Do something on next click');
            dispatch(toggleJiraTicketModal());

            console.log(driverObj);
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default createTicketsDriverObj;
